import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=af45e766&scoped=true&"
import script from "./spinner.vue?vue&type=script&lang=js&"
export * from "./spinner.vue?vue&type=script&lang=js&"
import style0 from "./spinner.vue?vue&type=style&index=0&id=af45e766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af45e766",
  null
  
)

export default component.exports